import { motion } from "framer-motion";
import { Plus } from "lucide-react";

const AREAS = {
  4: [
    "lg:col-start-1 lg:row-start-1 lg:row-span-3",
    "lg:col-start-2 lg:row-start-1 lg:row-span-2",
    "lg:col-start-2 lg:row-start-3 lg:row-span-2",
    "lg:col-start-1 lg:row-start-4 lg:row-span-1",
  ],
  5: [
    "lg:col-start-1 lg:row-start-1 lg:row-span-3",
    "lg:col-start-2 lg:row-start-1 lg:row-span-2",
    "lg:col-start-2 lg:row-start-3 lg:row-span-2",
    "lg:col-start-1 lg:row-start-4 lg:row-span-3",
    "lg:col-start-2 lg:row-start-5 lg:row-span-2",
  ],
};
const GRID = { 4: "lg:h-[760px] lg:grid-rows-4", 5: "lg:h-[1140px] lg:grid-rows-6" };

const Tile = ({ look, i, id, onOpen, area }) => (
  <motion.button
    type="button"
    onClick={() => onOpen(i)}
    data-testid={`look-${id}-${i}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
    className={`group relative w-[82vw] shrink-0 snap-start overflow-hidden bg-[#EDE8E1] text-left aspect-[4/5] sm:w-[55vw] lg:w-auto lg:aspect-auto ${area}`}
  >
    <img src={look.src} alt={look.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]" />
    <span className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-90 transition-opacity duration-500 lg:opacity-70 lg:group-hover:opacity-100" />
    <span className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-5 text-white">
      <span>
        <span className="block text-[11px] tracking-[0.28em] uppercase text-white/85">Look {String(i + 1).padStart(2, "0")}</span>
        <span className="block font-display text-2xl">{look.title}</span>
      </span>
      <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/70 transition-transform duration-500 group-hover:rotate-90">
        <Plus className="h-4 w-4" />
      </span>
    </span>
  </motion.button>
);

export const Gallery = ({ looks, id, onOpen }) => (
  <div data-testid={`gallery-${id}`}>
    <div className={`-mx-5 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-4 sm:-mx-10 sm:px-10 lg:mx-0 lg:grid ${GRID[looks.length]} lg:grid-cols-2 lg:overflow-visible lg:px-0 lg:pb-0 no-scrollbar`}>
      {looks.map((l, i) => <Tile key={l.src} look={l} i={i} id={id} onOpen={onOpen} area={AREAS[looks.length][i]} />)}
    </div>
    <p className="mt-3 text-sm text-[#6B645C] lg:hidden">Swipe to see all looks →</p>
  </div>
);
